import image1 from "../assets/images/image1.jpg";
import image2 from "../assets/images/image2.jpg";
import image3 from "../assets/images/image3.jpg";
import image4 from "../assets/images/image4.jpg";
import image5 from "../assets/images/image5.jpg";

export default function HomeComponent() {
  return (
    <>
      <div className="homeContent">
        <img src={image1} className="images" />
        <p>
          Forever Eastwards — powering Northeast India’s cold chain future.
          15,000+ MT storage capacity and growing every day. End-to-end cold
          storage and logistics solutions. From farm to market — seamless and
          reliable.
        </p>
      </div>

      <div className="homeContent">
        <img src={image4} className="images" />
        <img src={image3} className="images" />
        <p>
          Reducing food loss and improving farmer incomes. Strengthening
          resilient local economies. Connecting producers directly to markets.
        </p>
      </div>

      <div className="homeContent secondBlock">
        <p>
          Reducing food loss and improving farmer incomes. Strengthening
          resilient local economies. Connecting producers directly to markets.
        </p>

        <div className="imageColumn">
          {/* <img src={image4} className="images" /> */}
          <img src={image3} className="images" />
        </div>
      </div>

      <div className="homeContent">
        <img src={image5} className="images" />
        <p>
          Building the backbone of modern cold supply chains. Scaling capacity
          for tomorrow’s demand. Reliable. Scalable. Northeast-focused. Forever
          Eastwards — driving growth forward.
        </p>
      </div>
    </>
  );
}
